import React, {
  useContext,
  useState,
  useEffect
} from 'react';
import {
  Box,
  Container,
  makeStyles,
  Card,
  CardHeader,
  CardContent,
  Grid,
  Typography,
  IconButton,
  Menu,
  MenuItem,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  Button,
} from '@material-ui/core';
import { Navigate } from 'react-router-dom';
import { MoreVert } from '@material-ui/icons/';
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';
import AddIcon from '@material-ui/icons/Add';
import ErrorMessage from '../../../shared/component/UIElements/ErrorMessage';
import LoadingSpinner from '../../../shared/component/UIElements/LoadingSpinner';
import { AuthContext } from '../../../shared/context/auth-context';
import { useHttpClient } from '../../../hooks/http-hook';
import Modal from '../../../shared/component/Modal';
import Tabelas from '../../../shared/component/UIElements/Tabelas';

import Movel from './Movel';
import Nicho from './Nicho';
import Arquivo from './Arquivo';

const useStyles = makeStyles((theme) => ({
  root: {
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  },
  button: {
    color: 'white',
    paddingRight: '40px',
    paddingLeft: '40px',
    borderRadius: '23px',
    WebkitBorderRadius: '23px',
    MozBorderRadius: '23px'
  },
  header: {
    border: '1px solid #ACACAC',
    borderTopLeftRadius: '4px',
    borderTopRightRadius: '4px',
    '& .MuiCardHeader-title': {
      fontSize: '20px',
      fontWeight: 700,
      fontFamily: 'Roboto',
      color: '#3E3E3E'
    }
  },
  container: {
    borderLeft: '1px solid #ACACAC',
    borderRight: '1px solid #ACACAC',
    borderBottom: '1px solid #ACACAC',
    borderBottomLeftRadius: '4px',
    borderBottomRightRadius: '4px',
    padding: '0px 0px 0px 0px',
    '&:last-child': {
      paddingBottom: 0
    }
  },
  titulo: {
    fontSize: '14px',
    fontWeight: 400,
    color: '#828282',
    textAlign: 'left'
  },
  info: {
    padding: '30px 15px'
  },
  list: {
    color: '#808080',
    fontSize: '20px',
    fontFamily: 'Roboto',
    cursor: 'pointer'
  },
  list_ativo: {
    color: '#2980BA',
    fontSize: '20px',
    fontFamily: 'Roboto',
    cursor: 'pointer'
  },
  menu: {
    padding: '0px',
    marginRight: '20px'
  },
  icon: {
    color: '#2980BA',
    fontSize: '15px',
    marginRight: '5px'
  },
  hold_icon: {
    minWidth: 'auto',
    position: 'absolute',
    left: '-20px'
  }
}));

const Sala = (props) => {
  const {
    sala,
    onUpdate
  } = props;
  const auth = useContext(AuthContext);
  const {
    isLoading,
    error,
    sendRequest,
    clearError
  } = useHttpClient();
  const classes = useStyles();
  const create = auth.userPermission.permissoes.includes('create_mapas') || auth.userPermission.nome === 'Gestor do Sistema';
  const editar = auth.userPermission.permissoes.includes('update_mapas') || auth.userPermission.nome === 'Gestor do Sistema';
  const rmv = auth.userPermission.permissoes.includes('remove_mapas') || auth.userPermission.nome === 'Gestor do Sistema';
  const [navegar, setNavegar] = useState(false);

  const [anchorEl, setAnchorEl] = useState(null);

  // Controles dos Móveis / Modal / Create / Update / Modal Remove / Remove
  const [movelAtivo, setMovelAtivo] = useState(null);
  const [anchorElM, setAnchorElM] = useState(null);
  const [modalMovel, setModalMovel] = useState(null);
  const [addMovel, setAddMovel] = useState(null);
  const [updateMovel, setUpdateMovel] = useState(false);

  const [removeMovel, setRemoveMovel] = useState(false);
  const [modalMovelR, setModalMovelR] = useState(null);

  // Controles dos Nichos / Modal / Create / Update / Modal Remove / Remove
  const [nichoAtivo, setNichoAtivo] = useState(null);
  const [anchorElN, setAnchorElN] = useState(null);
  const [modalNicho, setModalNicho] = useState(null);
  const [updateNicho, setUpdateNicho] = useState(false);

  const [removeNicho, setRemoveNicho] = useState(false);
  const [modalNichoR, setModalNichoR] = useState(null);

  // Controles dos Arquivos / Modal / Create / Update / Modal Remove / Remove
  const [arquivoAtivo, setArquivoAtivo] = useState(null);
  const [anchorElA, setAnchorElA] = useState(null);
  const [modalArquivo, setModalArquivo] = useState(null);
  const [updateArquivo, setUpdateArquivo] = useState(false);

  const [removeArquivo, setRemoveArquivo] = useState(false);
  const [modalArquivoR, setModalArquivoR] = useState(null);

  // SALA MENU
  const [anchorSala, setAnchorSala] = useState(null);
  const [removeSala, setRemoveSala] = useState(false);
  const [modalSala, setModalSala] = useState(false);

  const [acervos, setAcervos] = useState([]);
  const [query, setQuery] = useState(null);
  const [remover, setRemover] = useState(false);

  // Acervos Controle

  useEffect(() => {
    const fetchAcervos = async () => {
      try {
        const response = await sendRequest(
          `${process.env.REACT_APP_BACKEND_URL}/mapas/query/`,
          'POST',
          JSON.stringify({
            sala: sala.id,
            movel: movelAtivo,
            nicho: nichoAtivo,
            arq: arquivoAtivo,
          }),
          {
            'Content-Type': 'application/json',
            'x-access-token': auth.token
          }
        );
        if (response.sucesso) {
          console.log(response.data);
          setAcervos(() => {
            const data = [...response.data.map((acervo) => ({
              id: acervo._id,
              nome: {
                conteudo: acervo.nome,
                avatar: acervo.destaque !== undefined ? `${process.env.REACT_APP_BACKEND_IMG}${acervo.destaque.caminho}` : '',
                tipo: 'avatar'
              },
              criacao: {
                conteudo: new Date(acervo.createdDate).toLocaleString(),
                tipo: 'data'
              },
              estado: {
                conteudo: acervo.status,
                tipo: 'text'
              },
              situacao: {
                conteudo: acervo.situacao.nome,
                tipo: 'texto'
              },
              exibir: {
                conteudo: acervo.exibicao,
                tipo: 'exibir',
                pode: response.editar,
              },
              edit: response.editar,
              delete: response.deletar
            }))];
            return data;
          });
        }
      } catch (err) {
        console.log(err);
      }
    };
    fetchAcervos();
  }, [sala, movelAtivo, nichoAtivo, arquivoAtivo]);

  const handleBusca = (event) => {
    const searchLower = String(event.target.value).toLowerCase();
    if (String(searchLower).trim().length > 0) {
      const filtradas = acervos.filter((acerv) => String(acerv.nome.conteudo).toLowerCase().includes(searchLower));
      console.log(filtradas);
      setQuery(filtradas);
    } else {
      setQuery(null);
    }
  };

  const handleVisibility = async (id) => {
    try {
      const responseData = await sendRequest(
        `${process.env.REACT_APP_BACKEND_URL}/acervos/visibilidade/${id}`,
        'POST',
        null,
        {
          'Content-Type': 'application/json',
          'x-access-token': auth.token
        }
      );

      if (responseData.sucesso) {
        setAcervos((prevState) => {
          const data = prevState.map((acervo) => {
            if (acervo.id === id) {
              acervo.exibir.conteudo = !acervo.exibir.conteudo;
            }
            return acervo;
          });
          return data;
        });
      }
    } catch (err) {
      console.log(err);
    }
  };
  const handleEditAcervo = (qual) => {
    setNavegar(`acervos/${qual}`);
  };
  const fecharDeletar = () => {
    setRemover(false);
  };
  const abrirDeletar = (qual) => {
    setRemover(qual);
  };

  const handleDelete = async () => {
    try {
      const responseData = await sendRequest(
        `${process.env.REACT_APP_BACKEND_URL}/acervos/${remover}`,
        'DELETE',
        null,
        {
          'Content-Type': 'application/json',
          'x-access-token': auth.token
        }
      );
      console.log(responseData);
      if (responseData.sucesso) {
        setAcervos((prevState) => {
          const data = [...prevState.filter((item) => item.id !== remover)];
          setRemover(false);
          return data;
        });
      }
    } catch (err) {
      console.log(err);
    }
  };

  // ------

  const handleEdit = (qual) => {
    setNavegar(`mapas/${qual}`);
  };
  if (navegar) {
    return <Navigate to={`/app/${navegar}`} />;
  }

  const handleClickSala = (event) => {
    setAnchorSala(event.currentTarget);
    setRemoveSala(sala.id);
  };

  const handleRemoveSala = () => {
    setAnchorSala(null);
    setModalSala(true);
  };

  const handleCloseSala = () => {
    setAnchorSala(null);
    setRemoveSala(false);
    setModalSala(false);
  };

  const handleRemoveSalaSucess = async () => {
    setAnchorSala(null);
    console.log('Remover sala');
    console.log(removeSala);
    try {
      const response = await sendRequest(
        `${process.env.REACT_APP_BACKEND_URL}/mapas/${removeSala}`,
        'DELETE',
        null,
        {
          'Content-Type': 'application/json',
          'x-access-token': auth.token
        }
      );
      console.log(response);
      if (response.sucesso) {
        console.log('Removeu a sala!');
        setRemoveSala(false);
        setModalSala(false);
        clearError();
        onUpdate(new Date());
      }
    } catch (err) {
      console.log(err);
    }
  };

  // --------

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClickMovel = (event, mov) => {
    setUpdateMovel(mov);
    setRemoveMovel(mov);
    setAnchorElM(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleCloseM = () => {
    setAnchorElM(null);
  };

  const handleAddMovel = () => {
    setUpdateMovel(false);
    setAnchorEl(null);
    setAddMovel(sala.id);
    setModalMovel(true);
  };

  const handleAddMovelClose = () => {
    setUpdateMovel(false);
    setAnchorEl(null);
    setAddMovel(null);
    setModalMovel(null);
  };

  const handleAddMovelSucess = () => {
    setUpdateMovel(false);
    setAnchorEl(null);
    setAddMovel(null);
    setModalMovel(null);
    onUpdate(new Date());
  };

  const handleAttMovel = () => {
    setAddMovel(null);
    setAnchorElM(null);
    setModalMovel(true);
  };

  const handleRemoveMovelClose = () => {
    setAnchorEl(null);
    setRemoveMovel(false);
    setModalMovelR(false);
  };

  const handleRemoveMovelSucess = async () => {
    setAnchorEl(null);
    console.log('Remover móvel');
    console.log(removeMovel);
    try {
      const response = await sendRequest(
        `${process.env.REACT_APP_BACKEND_URL}/mapas/${sala.id}/movel/${removeMovel._id}`,
        'DELETE',
        null,
        {
          'Content-Type': 'application/json',
          'x-access-token': auth.token
        }
      );
      console.log(response);
      if (response.sucesso) {
        console.log('Removeu imóvel à sala!');
        setRemoveMovel(false);
        setModalMovelR(false);
        clearError();
        onUpdate(new Date());
      }
    } catch (err) {
      console.log(err);
    }
  };

  const handleRemoveMovel = () => {
    setAnchorElM(null);
    setModalMovelR(true);
  };

  // Nichos

  const handleClickNicho = (event, nicho) => {
    setUpdateNicho(nicho);
    setRemoveNicho(nicho);
    setAnchorElN(event.currentTarget);
  };

  const handleCloseN = () => {
    setAnchorElN(null);
  };

  // ADICIONAR

  const handleAddNicho = () => {
    setUpdateNicho(false);
    setAnchorEl(null);
    setModalNicho(true);
  };

  const handleAddNichoClose = () => {
    setUpdateNicho(false);
    setAnchorEl(null);
    setModalNicho(null);
  };

  const handleAddNichoSucess = () => {
    setUpdateNicho(false);
    setAnchorEl(null);
    setModalNicho(null);
    onUpdate(new Date());
  };

  // ATUALIZAR

  const handleAttNicho = () => {
    setAnchorElN(null);
    setModalNicho(true);
  };

  // REMOVER

  const handleRemoveNicho = () => {
    setAnchorElN(null);
    setModalNichoR(true);
  };

  const handleRemoveNichoClose = () => {
    setAnchorElN(null);
    setRemoveNicho(false);
    setModalNichoR(false);
  };

  const handleRemoveNichoSucess = async () => {
    setAnchorEl(null);
    console.log('Remover nicho');
    console.log(removeNicho);
    try {
      const response = await sendRequest(
        `${process.env.REACT_APP_BACKEND_URL}/mapas/nicho/${removeNicho._id}`,
        'DELETE',
        null,
        {
          'Content-Type': 'application/json',
          'x-access-token': auth.token
        }
      );
      console.log(response);
      if (response.sucesso) {
        console.log('Removeu nicho à sala!');
        setRemoveNicho(false);
        setModalNichoR(false);
        clearError();
        onUpdate(new Date());
      }
    } catch (err) {
      console.log(err);
    }
  };

  // Arquivo

  // ADICIONAR

  const handleAddArquivo = () => {
    setUpdateArquivo(false);
    setAnchorEl(null);
    setModalArquivo(true);
  };

  const handleAddArquivoClose = () => {
    setUpdateArquivo(false);
    setAnchorEl(null);
    setModalArquivo(null);
  };

  const handleAddArquivoSucess = () => {
    setUpdateArquivo(false);
    setAnchorEl(null);
    setModalArquivo(null);
    onUpdate(new Date());
  };

  // UPDATE

  const handleAttArquivo = () => {
    setAnchorElA(null);
    setModalArquivo(true);
  };

  const handleClickArquivo = (event, arquivo) => {
    setUpdateArquivo(arquivo);
    setRemoveArquivo(arquivo);
    setAnchorElA(event.currentTarget);
  };

  // REMOVER

  const handleRemoveArquivo = () => {
    setAnchorElA(null);
    setModalArquivoR(true);
  };

  const handleRemoveArquivoClose = () => {
    setAnchorElA(null);
    setRemoveArquivo(false);
    setModalArquivoR(false);
  };

  const handleRemoveArquivoSucess = async () => {
    setAnchorElA(null);
    console.log('Remover arquivo');
    console.log(removeArquivo);
    try {
      const response = await sendRequest(
        `${process.env.REACT_APP_BACKEND_URL}/mapas/arquivo/${removeArquivo._id}`,
        'DELETE',
        null,
        {
          'Content-Type': 'application/json',
          'x-access-token': auth.token
        }
      );
      console.log(response);
      if (response.sucesso) {
        console.log('Removeu arquivo à sala!');
        setRemoveArquivo(false);
        setModalArquivoR(false);
        clearError();
        onUpdate(new Date());
      }
    } catch (err) {
      console.log(err);
    }
  };

  const handleCloseA = () => {
    setAnchorElA(null);
  };

  const filtroMovel = sala.moveis.filter((mov) => mov._id === movelAtivo);
  let filtroArquivos = [];
  if (nichoAtivo && filtroMovel.length > 0) {
    const nicho = filtroMovel[0].nichos.filter((n) => n._id === nichoAtivo);
    if (nicho.length > 0) {
      filtroArquivos = nicho[0].arquivos;
    }
  }
  const coluna = (nichoAtivo ? 4 : 6);
  return (
    <Container maxWidth={false}>
      <Box mt={3}>
        <Card raised>
          <CardHeader
            title={sala.nome}
            className={classes.header}
            action={(
              <>
                <IconButton
                  aria-label="add"
                  onClick={handleClick}
                >
                  <AddIcon />
                </IconButton>
                <IconButton
                  aria-label="settings"
                  onClick={handleClickSala}
                >
                  <MoreVert />
                </IconButton>
              </>
            )}
          />
          <Menu
            id="simple-menu-add"
            anchorEl={anchorEl}
            keepMounted
            open={Boolean(anchorEl)}
            onClose={handleClose}
          >
            <MenuItem
              onClick={handleAddMovel}
              disabled={!create}
            >
              Adicionar Móvel
            </MenuItem>
            <MenuItem
              onClick={handleAddNicho}
              disabled={!create}
            >
              Adicionar Nicho
            </MenuItem>
            <MenuItem
              onClick={handleAddArquivo}
              disabled={!create}
            >
              Adicionar Arquivo
            </MenuItem>
          </Menu>
          <Menu
            id="simple-menu-config"
            anchorEl={anchorSala}
            keepMounted
            open={Boolean(anchorSala)}
            onClose={handleCloseSala}
          >
            <MenuItem
              onClick={() => handleEdit(sala.id)}
              disabled={!editar}
            >
              Atualizar Sala
            </MenuItem>
            <MenuItem
              onClick={handleRemoveSala}
              disabled={!rmv}
            >
              Remover Sala
            </MenuItem>
          </Menu>
          <CardContent
            className={classes.container}
          >
            <Grid
              container
              className={classes.info}
            >
              <Grid item xs={6}>
                {sala.imagem !== undefined && (
                  <img src={`${process.env.REACT_APP_BACKEND_IMG}${sala.imagem.caminho}`} alt={sala.imagem.original} />
                )}
              </Grid>
              <Grid item xs={6}>
                <Grid container>
                  <Grid item xs={movelAtivo ? coluna : 12}>
                    <Typography
                      color="textPrimary"
                      align="left"
                      variant="h1"
                      className={classes.titulo}
                    >
                      Móveis
                    </Typography>
                    <List component="nav" aria-label="main mailbox folders">
                      {sala.moveis.map((mov) => (
                        <ListItem
                          disableGutters
                        >
                          {movelAtivo === mov._id && (
                            <ListItemIcon className={classes.hold_icon}>
                              <FiberManualRecordIcon className={classes.icon} />
                            </ListItemIcon>
                          )}
                          <ListItemText
                            className={movelAtivo === mov._id ? classes.list_ativo : classes.list}
                            onClick={() => {
                              setMovelAtivo((prevState) => {
                                return prevState === mov._id ? null : mov._id;
                              });
                              setNichoAtivo(null);
                              setArquivoAtivo(null);
                            }}
                          >
                            {mov.nome}
                          </ListItemText>
                          <IconButton
                            aria-label="settings"
                            className={classes.menu}
                            onClick={(event) => handleClickMovel(event, mov)}
                          >
                            <MoreVert />
                          </IconButton>
                        </ListItem>
                      ))}
                    </List>
                    <Menu
                      id="simple-menu-movel"
                      anchorEl={anchorElM}
                      keepMounted
                      open={Boolean(anchorElM)}
                      onClose={handleCloseM}
                    >
                      <MenuItem
                        onClick={handleAttMovel}
                        disabled={!editar}
                      >
                        Atualizar
                      </MenuItem>
                      <MenuItem
                        onClick={handleRemoveMovel}
                        disabled={!rmv}
                      >
                        Remover
                      </MenuItem>
                    </Menu>
                  </Grid>
                  {movelAtivo && filtroMovel.length > 0 && (
                    <>
                      <Grid item xs={filtroArquivos.length > 0 ? 4 : 6}>
                        <Typography
                          color="textPrimary"
                          align="left"
                          variant="h1"
                          className={classes.titulo}
                        >
                          Nichos
                        </Typography>
                        <List component="nav" aria-label="nichos">
                          {filtroMovel[0].nichos.map((nicho) => (
                            <ListItem
                              disableGutters
                            >
                              {nichoAtivo === nicho._id && (
                                <ListItemIcon className={classes.hold_icon}>
                                  <FiberManualRecordIcon className={classes.icon} />
                                </ListItemIcon>
                              )}
                              <ListItemText
                                className={nichoAtivo === nicho._id ? classes.list_ativo : classes.list}
                                onClick={() => {
                                  setNichoAtivo((prevState) => {
                                    return prevState === nicho._id ? null : nicho._id;
                                  });
                                  setArquivoAtivo(null);
                                }}
                              >
                                {nicho.nome}
                              </ListItemText>
                              <IconButton
                                aria-label="settings"
                                className={classes.menu}
                                onClick={(event) => handleClickNicho(event, nicho)}
                              >
                                <MoreVert />
                              </IconButton>
                            </ListItem>
                          ))}
                        </List>
                        <Menu
                          id="simple-menu-nicho"
                          anchorEl={anchorElN}
                          keepMounted
                          open={Boolean(anchorElN)}
                          onClose={handleCloseN}
                        >
                          <MenuItem
                            onClick={handleAttNicho}
                            disabled={!editar}
                          >
                            Atualizar
                          </MenuItem>
                          <MenuItem
                            onClick={handleRemoveNicho}
                            disabled={!rmv}
                          >
                            Remover
                          </MenuItem>
                        </Menu>
                      </Grid>
                      {filtroArquivos.length > 0 && (
                        <Grid item xs={4}>
                          <Typography
                            color="textPrimary"
                            align="left"
                            variant="h1"
                            className={classes.titulo}
                          >
                            Arquivos
                          </Typography>
                          <List component="nav" aria-label="nichos">
                            {filtroArquivos.map((arquivo) => (
                              <ListItem
                                disableGutters
                              >
                                {arquivoAtivo === arquivo._id && (
                                  <ListItemIcon className={classes.hold_icon}>
                                    <FiberManualRecordIcon className={classes.icon} />
                                  </ListItemIcon>
                                )}
                                <ListItemText
                                  className={arquivoAtivo === arquivo._id ? classes.list_ativo : classes.list}
                                  onClick={() => {
                                    setArquivoAtivo((prevState) => {
                                      return prevState === arquivo._id ? null : arquivo._id;
                                    });
                                  }}
                                >
                                  {arquivo.nome}
                                </ListItemText>
                                <IconButton
                                  aria-label="settings"
                                  className={classes.menu}
                                  onClick={(event) => handleClickArquivo(event, arquivo)}
                                >
                                  <MoreVert />
                                </IconButton>
                              </ListItem>
                            ))}
                          </List>
                          <Menu
                            id="simple-menu-arquivo"
                            anchorEl={anchorElA}
                            keepMounted
                            open={Boolean(anchorElA)}
                            onClose={handleCloseA}
                          >
                            <MenuItem
                              onClick={handleAttArquivo}
                              disabled={!editar}
                            >
                              Atualizar
                            </MenuItem>
                            <MenuItem
                              onClick={handleRemoveArquivo}
                              disabled={!rmv}
                            >
                              Remover
                            </MenuItem>
                          </Menu>
                        </Grid>
                      )}
                    </>
                  )}
                </Grid>
              </Grid>
            </Grid>
            <Grid
              container
              className={classes.info}
            >
              <Grid item xs={12}>
                {(acervos.length > 0 || query !== null) && (
                  <>
                    <Tabelas
                      data={query !== null ? query : acervos}
                      estrutura={[
                        { id: 'nome', tipo: 'avatar', nome: 'Nome' },
                        { id: 'criacao', tipo: 'data', nome: 'Data de Cadastro' },
                        { id: 'estado', tipo: 'texto', nome: 'Estado' },
                        { id: 'situacao', tipo: 'texto', nome: 'Situação' },
                        { id: 'exibir', tipo: 'exibir', nome: 'Exibir no Site' },
                        { id: 'acoes', tipo: 'acoes', nome: 'Ações' },
                      ]}
                      edit={handleEditAcervo}
                      remove={abrirDeletar}
                      busca={handleBusca}
                      exibir={handleVisibility}
                      placeholder="Pesquisar item do acervo"
                    />
                    {isLoading && <LoadingSpinner asOverlay />}
                    <ErrorMessage error={error} onClear={clearError} />
                  </>
                )}
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Box>
      <Movel
        open={Boolean(modalMovel)}
        sala={addMovel}
        editar={updateMovel}
        onClose={handleAddMovelClose}
        onSalvar={handleAddMovelSucess}
      />
      <Modal
        open={Boolean(modalMovelR)}
        close={handleRemoveMovelClose}
        title="Deseja realmente remover este móvel da sala?"
      >
        <Button
          color="primary"
          variant="contained"
          style={{ marginRight: '15px' }}
          onClick={handleRemoveMovelSucess}
        >
          Remover Móvel
        </Button>
        <Button
          color="primary"
          variant="contained"
          onClick={handleRemoveMovelClose}
        >
          Cancelar
        </Button>
        {isLoading && <LoadingSpinner asOverlay />}
        <ErrorMessage error={error} onClear={clearError} />
      </Modal>
      <Nicho
        open={Boolean(modalNicho)}
        sala={sala}
        editar={updateNicho}
        onClose={handleAddNichoClose}
        onSalvar={handleAddNichoSucess}
      />
      <Modal
        open={Boolean(modalNichoR)}
        close={handleRemoveNichoClose}
        title="Deseja realmente remover este nicho da móvel?"
      >
        <Button
          color="primary"
          variant="contained"
          style={{ marginRight: '15px' }}
          onClick={handleRemoveNichoSucess}
        >
          Remover Nicho
        </Button>
        <Button
          color="primary"
          variant="contained"
          onClick={handleRemoveNichoClose}
        >
          Cancelar
        </Button>
        {isLoading && <LoadingSpinner asOverlay />}
        <ErrorMessage error={error} onClear={clearError} />
      </Modal>
      <Arquivo
        open={Boolean(modalArquivo)}
        sala={sala}
        editar={updateArquivo}
        onClose={handleAddArquivoClose}
        onSalvar={handleAddArquivoSucess}
      />
      <Modal
        open={Boolean(modalArquivoR)}
        close={handleRemoveArquivoClose}
        title="Deseja realmente remover este arquivo?"
      >
        <Button
          color="primary"
          variant="contained"
          style={{ marginRight: '15px' }}
          onClick={handleRemoveArquivoSucess}
        >
          Remover Arquivo
        </Button>
        <Button
          color="primary"
          variant="contained"
          onClick={handleRemoveArquivoClose}
        >
          Cancelar
        </Button>
        {isLoading && <LoadingSpinner asOverlay />}
        <ErrorMessage error={error} onClear={clearError} />
      </Modal>
      <Modal
        open={Boolean(modalSala)}
        close={handleCloseSala}
        title="Deseja realmente remover esta Sala?"
      >
        <Button
          color="primary"
          variant="contained"
          style={{ marginRight: '15px' }}
          onClick={handleRemoveSalaSucess}
        >
          Remover Sala
        </Button>
        <Button
          color="primary"
          variant="contained"
          onClick={handleCloseSala}
        >
          Cancelar
        </Button>
        {isLoading && <LoadingSpinner asOverlay />}
        <ErrorMessage error={error} onClear={clearError} />
      </Modal>
      <Modal
        open={Boolean(remover)}
        close={fecharDeletar}
        title="Deseja realmente remover este item do Acervo?"
      >
        <Button
          color="primary"
          variant="contained"
          style={{ marginRight: '15px' }}
          onClick={handleDelete}
        >
          Remover Acervo
        </Button>
        <Button
          color="primary"
          variant="contained"
          onClick={fecharDeletar}
        >
          Cancelar
        </Button>
        {isLoading && <LoadingSpinner asOverlay />}
        <ErrorMessage error={error} onClear={clearError} />
      </Modal>
    </Container>
  );
};

export default Sala;
